import React from 'react';
import { STATUS_PLAYING } from './constants';

const Controls = ({ onReset, gameStatus }) => {
    return (
        <button
            onClick={onReset}
            style={{ marginBottom: '1rem', backgroundColor: '#3b82f6', color: 'white', fontWeight: 'bold', padding: '0.5rem 1rem', borderRadius: '0.25rem', cursor: 'pointer', border: 'none' }}
        >
            {gameStatus !== STATUS_PLAYING ? 'Play Again' : 'Reset Game'}
        </button>
    );
};

export default Controls;